import { render, staticRenderFns } from "./IlmoitusListItem.vue?vue&type=template&id=29b09585"
import script from "./IlmoitusListItem.vue?vue&type=script&lang=js"
export * from "./IlmoitusListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports